import { createAsyncThunk } from "@reduxjs/toolkit";
import {
    ActorProfileMaster,
    GetWhoIsInDetailRequest,
    GetWhoIsInRequest,
    IRejectWithValue,
    PhpClientPaginatedResponse,
    PhpResponse,
    WhoIsInDetail,
} from "../../../types";
import { phpClient } from "../../../network";
import { DateTimeUtil } from "../../../utils";

export const getWhoIsWorking = createAsyncThunk<
    PhpClientPaginatedResponse<ActorProfileMaster[]>,
    GetWhoIsInRequest,
    IRejectWithValue
>("/dashboard/who-is-working", async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
        const response = await phpClient.postPaginated<ActorProfileMaster[]>({
            url: "/attendance/online",
            data,
        });
        return response;
    } catch (error: any) {
        console.error("Error in getWhoIsWorking:", error);
        return rejectWithValue(error.message);
    }
});

export const getWhoIsWorkingDetails = createAsyncThunk<
    WhoIsInDetail | undefined,
    GetWhoIsInDetailRequest,
    IRejectWithValue
>("/dashboard/who-is-working-details", async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
        const { raw_id } = data;
        const response = await phpClient.get<PhpResponse<WhoIsInDetail>>({
            url: `/Attendance/raw/${raw_id}`,
        });
        return response.data;
    } catch (error: any) {
        console.error("Error in getWhoIsWorkingDetails:", error);
        return rejectWithValue(error.message);
    }
});